import { useDispatch } from 'react-redux';
import {
  clearItems as clearItemsAction,
  incrementItemQuantity as incrementItemQuantityAction,
  setItemQuantity,
} from '@client/cart/redux/cartQuantity/redux';

interface CartQuantityActions {
  setCartItemQuantity: (sku: string, quantity: number, attemptedQuantity: number) => void;
  incrementCartItemQuantity: (sku: string, amount?: number) => void;
  clearCartItems: () => void;
}

export const useCartQuantityActions = (): CartQuantityActions => {
  const dispatch = useDispatch();

  const setCartItemQuantity = (
    sku: string,
    quantity: number,
    attemptedQuantity: number,
  ) => {
    dispatch(setItemQuantity({ sku, quantity, attemptedQuantity }));
  };

  const incrementCartItemQuantity = (
    sku: string,
    amount = 1,
  ) => {
    dispatch(incrementItemQuantityAction({ sku, amount }));
  };

  const clearCartItems = () => {
    dispatch(clearItemsAction());
  };

  return {
    setCartItemQuantity,
    incrementCartItemQuantity,
    clearCartItems,
  };
};
